import sendHttpPostRequest from "./sendHttpPostRequest";
import sendHttpPutRequest from "./sendHttpPutRequest";

const UserCollectionsService = {
  addTranslation: (language, seedFromLanguage) => {
    return sendHttpPostRequest(
      "/users/user/addtranslation",
      JSON.stringify({
        language: language,
        seedFromLanguage: seedFromLanguage,
      })
    );
  },

  deleteTranslation: (translationId) => {
    return sendHttpPostRequest(
      "/users/user/deletetranslation",
      JSON.stringify({
        translationId: translationId,
      })
    );
  },

  updateTranslationInfo: (translationId, object) => {
    return sendHttpPutRequest(
      "/users/user/updatetranslationinfo",
      JSON.stringify({
        translationId: translationId,
        object: object,
      })
    );
  },

  createTranslationItem: (translationId, objectToAdd, collectionToAddTo) => {
    return sendHttpPostRequest(
      "/users/user/addtranslationitem",
      JSON.stringify({
        translationId: translationId,
        objectToAdd: objectToAdd,
        collectionToAddTo: collectionToAddTo,
      })
    );
  },

  updateTranslationItem: (translationId, objectToUpdate, collectionToUpdate) => {
    return sendHttpPutRequest(
      "/users/user/updatetranslationitem",
      JSON.stringify({
        translationId: translationId,
        objectToUpdate: objectToUpdate,
        collectionToUpdate: collectionToUpdate,
      })
    );
  },

  deleteTranslationItem: (translationId, objectToDeleteId, collectionToDelete) => {
    return sendHttpPostRequest(
      "/users/user/deletetranslationitem",
      JSON.stringify({
        translationId: translationId,
        objectToDeleteId: objectToDeleteId,
        collectionToDelete: collectionToDelete,
      })
    );
  },
};
export default UserCollectionsService;
